import { getToken, handleResponse, nextJsonApi } from '@/API/core';

const userPermissions = {
  getPermissionsBasedOnUserId: async (userId: string) => {
    let response = null;
    const token = await getToken();
    try {
      response = await nextJsonApi.get(`/user-permissions/${userId}/user`, {
        headers: {
          Authorization: `Bearer ${token}`,
        },
      });
    } catch (e) {
      response = e;
    }
    return handleResponse(response);
  },
  getRowDataBasedOnUserId: async (userId: string) => {
    let response = null;
    const token = await getToken();
    try {
      response = await nextJsonApi.get(`/user-permissions/${userId}/row-data`, {
        headers: {
          Authorization: `Bearer ${token}`,
        },
      });
    } catch (e) {
      response = e;
    }
    return handleResponse(response);
  },
  updateStatus: async (uniqueId: string, status: boolean) => {
    let response = null;
    const token = await getToken();
    try {
      response = await nextJsonApi.put(
        `/user-permissions/${uniqueId}/status`,
        { status },
        {
          headers: {
            Authorization: `Bearer ${token}`,
          },
        }
      );
    } catch (e) {
      response = e;
    }
    return handleResponse(response);
  },
  updateUserPermissions: async (userId: string, permissions: string[]) => {
    let response = null;
    const token = await getToken();
    try {
      response = await nextJsonApi.put(
        `/user-permissions/${userId}/update`,
        {
          permissions: permissions,
        },
        {
          headers: {
            Authorization: `Bearer ${token}`,
          },
        }
      );
    } catch (e) {
      response = e;
    }
    return handleResponse(response);
  },
};

export default userPermissions;
